import { Sun } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function Marquee() {
  const { T } = useLang();
  const items = [...T.marquee, ...T.marquee, ...T.marquee];
  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-federasol-terra/10 bg-federasol-blush/70 py-4"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-serif text-xl italic text-federasol-terra/85 md:text-2xl">
                  {item}
                </span>
                <Sun className="h-3.5 w-3.5 text-federasol-rose" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
